var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodataInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7164 32.5717C63.7164 32.5717 31.3756 55.1778 17.8315 84.9434C4.2873 114.709 10.5652 149.653 35.3196 172.82C60.074 195.988 99.9223 186.907 136.008 198.725C172.093 210.544 208.856 201.932 219.945 164.668C231.035 127.404 205.097 117.679 195.311 77.7189C185.526 37.7592 140.666 -16.5009 63.7164 32.5717Z",
    fill: "#548AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.7164 32.5717C63.7164 32.5717 31.3756 55.1778 17.8315 84.9434C4.2873 114.709 10.5652 149.653 35.3196 172.82C60.074 195.988 99.9223 186.907 136.008 198.725C172.093 210.544 208.856 201.932 219.945 164.668C231.035 127.404 205.097 117.679 195.311 77.7189C185.526 37.7592 140.666 -16.5009 63.7164 32.5717Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.93 49.1797H80.7383V96.9717H116.93V49.1797Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.716 54.75H84.9551V91.406H112.716V54.75Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6412 73.7734H26.4492V121.565H62.6412V73.7734Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4291 79.3438H30.668V116H58.4291V79.3438Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.962 86.1389C182.447 84.9886 190.824 74.746 189.674 63.2615C188.524 51.777 178.281 43.3996 166.796 44.5499C155.312 45.7003 146.934 55.9428 148.085 67.4273C149.235 78.9118 159.478 87.2893 170.962 86.1389Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.42 82.4976C180.88 81.0906 187.408 72.2815 186.001 62.822C184.594 53.3624 175.785 46.8345 166.325 48.2415C156.866 49.6485 150.338 58.4576 151.745 67.9171C153.152 77.3767 161.961 83.9046 171.42 82.4976Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.828 65.3516H168.876V81.29",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.838 164.867L162.169 176.676C162.382 177.018 162.499 177.411 162.509 177.814C162.518 178.217 162.42 178.615 162.224 178.967C162.028 179.319 161.742 179.613 161.394 179.817C161.047 180.021 160.651 180.128 160.248 180.128H145.275C145.677 180.128 146.071 180.021 146.418 179.818C146.765 179.614 147.051 179.322 147.247 178.972C147.444 178.621 147.543 178.224 147.534 177.822C147.526 177.42 147.411 177.028 147.2 176.685L140.129 165.132L154.838 164.867Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.839 164.867L140.107 165.132L142.836 169.577H157.763L154.839 164.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.67 167.492H175.591C176.337 167.492 176.941 166.888 176.941 166.142V115.956C176.941 115.21 176.337 114.605 175.591 114.605H115.67C114.924 114.605 114.32 115.21 114.32 115.956V166.142C114.32 166.888 114.924 167.492 115.67 167.492Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.301 167.492H173.222C173.968 167.492 174.572 166.888 174.572 166.142V115.956C174.572 115.21 173.968 114.605 173.222 114.605H113.301C112.555 114.605 111.951 115.21 111.951 115.956V166.142C111.951 166.888 112.555 167.492 113.301 167.492Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 114.602H172.47C172.746 114.602 173.02 114.656 173.275 114.762C173.53 114.868 173.762 115.023 173.958 115.219C174.153 115.415 174.308 115.647 174.413 115.902C174.518 116.158 174.572 116.432 174.572 116.708V158.004H111.932V116.708C111.932 116.43 111.987 116.155 112.094 115.898C112.201 115.641 112.358 115.408 112.555 115.212C112.753 115.016 112.987 114.861 113.245 114.757C113.503 114.652 113.779 114.599 114.057 114.602Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.582 155.125H171.941V116.71H114.582V155.125Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.098 120.922H134.784V125.274H134.098V120.922Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.893 122.134V125.28H135.275V120.914H136.138L136.844 123.526V120.914H137.456V125.28H136.751L135.893 122.134Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.983 124.491L139.508 120.928H140.129L139.466 125.28H138.44L137.768 120.914H138.459L138.983 124.491Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.393 121.973C140.383 121.83 140.403 121.687 140.451 121.553C140.499 121.418 140.575 121.295 140.672 121.19C140.77 121.086 140.888 121.003 141.019 120.946C141.15 120.889 141.292 120.859 141.435 120.859C141.578 120.859 141.719 120.889 141.85 120.946C141.981 121.003 142.099 121.086 142.197 121.19C142.295 121.295 142.37 121.418 142.418 121.553C142.466 121.687 142.486 121.83 142.476 121.973V124.242C142.486 124.385 142.466 124.528 142.418 124.662C142.37 124.797 142.295 124.92 142.197 125.025C142.099 125.129 141.981 125.212 141.85 125.269C141.719 125.326 141.578 125.355 141.435 125.355C141.292 125.355 141.15 125.326 141.019 125.269C140.888 125.212 140.77 125.129 140.672 125.025C140.575 124.92 140.499 124.797 140.451 124.662C140.403 124.528 140.383 124.385 140.393 124.242V121.973ZM141.08 124.293C141.08 124.604 141.219 124.72 141.437 124.72C141.655 124.72 141.79 124.604 141.79 124.293V121.936C141.79 121.62 141.655 121.504 141.437 121.504C141.219 121.504 141.08 121.62 141.08 121.936V124.293Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.914 120.922H143.601V125.274H142.914V120.922Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.096 123.659V124.239C146.096 124.939 145.748 125.338 145.075 125.338C144.931 125.35 144.786 125.329 144.652 125.276C144.517 125.224 144.396 125.142 144.297 125.036C144.199 124.93 144.125 124.804 144.082 124.666C144.039 124.528 144.028 124.382 144.05 124.239V121.97C144.028 121.827 144.039 121.681 144.082 121.543C144.125 121.405 144.199 121.278 144.297 121.173C144.396 121.067 144.517 120.985 144.652 120.932C144.786 120.88 144.931 120.859 145.075 120.87C145.748 120.87 146.096 121.269 146.096 121.97V122.392H145.451V121.928C145.451 121.613 145.312 121.497 145.094 121.497C144.876 121.497 144.736 121.613 144.736 121.928V124.285C144.736 124.596 144.876 124.707 145.094 124.707C145.312 124.707 145.451 124.596 145.451 124.285V123.659H146.096Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.199 122.77H148.127V123.392H147.199V124.672H148.387V125.28H146.531V120.914H148.387V121.568H147.199V122.77Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.909 127.016H116.967V130.291H169.909V127.016Z",
    fill: "#548AFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.139 151.5V132.531H169.566V152.191",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M117.314 138.914H169.394",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.08 132.398V152.197",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9075 177.484H87.084V178.092H88.9075V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3352 177.484H89.5117V178.092H91.3352V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7649 177.484H91.9414V178.092H93.7649V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1927 177.484H94.3691V178.092H96.1927V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6243 177.484H96.8008V178.092H98.6243V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 177.484H99.2285V178.092H101.052V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M103.482 177.484H101.658V178.092H103.482V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.909 177.484H104.086V178.092H105.909V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M108.341 177.484H106.518V178.092H108.341V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M110.767 177.484H108.943V178.092H110.767V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.199 177.484H111.375V178.092H113.199V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.624 177.484H113.801V178.092H115.624V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M118.056 177.484H116.232V178.092H118.056V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M120.484 177.484H118.66V178.092H120.484V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.915 177.484H121.092V178.092H122.915V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.343 177.484H123.52V178.092H125.343V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.773 177.484H125.949V178.092H127.773V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.2 177.484H128.377V178.092H130.2V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.63 177.484H130.807V178.092H132.63V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.058 177.484H133.234V178.092H135.058V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.49 177.484H135.666V178.092H137.49V177.484Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138.811 178.172H86.1426V180.135H138.811V178.172Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138.811 178.172H125.963V180.135H138.811V178.172Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M189.721 135.773V128.984H184.849V135.773H181.605L187.285 145.609L192.96 135.773H189.721Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.193 111.594V110.898",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M152.193 109.526V104.631C152.193 103.769 152.536 102.943 153.145 102.334C153.754 101.725 154.58 101.383 155.441 101.383H184.209C185.071 101.383 185.897 101.725 186.506 102.334C187.115 102.943 187.457 103.769 187.457 104.631V125.743",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10,
    strokeDasharray: "1.37 1.37"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M187.457 126.438V127.133",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M170.636 149.641H200.1C200.869 149.641 201.607 149.946 202.151 150.49C202.695 151.034 203 151.771 203 152.541V175.977H167.736V152.541C167.736 151.771 168.042 151.034 168.586 150.49C169.13 149.946 169.867 149.641 170.636 149.641Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M201.144 146.391H169.592V175.975H201.144V146.391Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M151.664 160.586H206.978C207.448 160.586 207.898 160.773 208.231 161.105C208.563 161.437 208.75 161.888 208.75 162.358V179.921H151.678V160.586H151.664Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M144.331 160.586H199.199C199.493 160.586 199.776 160.703 199.984 160.911C200.191 161.119 200.308 161.401 200.308 161.695V179.921H143.236V161.695C143.236 161.403 143.351 161.123 143.556 160.916C143.761 160.708 144.04 160.59 144.331 160.586Z",
    fill: "#636363",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M148.137 160.586H195.4V173.244C195.4 174.281 194.988 175.276 194.254 176.01C193.521 176.743 192.526 177.155 191.488 177.155H152.048C151.011 177.155 150.016 176.743 149.282 176.01C148.549 175.276 148.137 174.281 148.137 173.244V160.586Z",
    fill: "#636363",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M186.653 160.586H156.883V179.921H186.653V160.586Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M159.49 170.641C159.49 170.641 160.501 175.452 158.219 177.229C155.936 179.007 144.535 178.621 144.535 178.621H181.79C181.79 178.621 186.351 179.763 186.096 171.527L159.49 170.641Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M182.332 177.908H158.482L159.786 177.18H183.269L182.332 177.908Z",
    fill: "#548AFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M161.589 172.336C161.589 175.278 160.893 176.359 160.893 176.359H183.874C183.874 176.359 184.881 175.742 185.113 172.415",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M161.281 174.977H184.569",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M161.514 173.5H184.881",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M176.523 176.28C176.523 176.28 177.683 175.199 177.605 172.336",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M186.653 160.586H156.883V171.68H186.653V160.586Z",
    fill: "#636363",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M186.648 178.648H154.182V179.92H186.648V178.648Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M155.807 160.583H187.725V162.119C187.724 162.929 187.402 163.706 186.83 164.279C186.258 164.853 185.482 165.177 184.672 165.181H158.878C158.065 165.181 157.285 164.858 156.71 164.283C156.134 163.708 155.811 162.927 155.811 162.114V160.578L155.807 160.583Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M198.468 164.037C198.468 164.234 198.409 164.427 198.3 164.591C198.19 164.755 198.034 164.883 197.852 164.958C197.67 165.034 197.469 165.054 197.276 165.015C197.082 164.977 196.904 164.882 196.765 164.742C196.625 164.603 196.53 164.425 196.492 164.231C196.453 164.038 196.473 163.837 196.549 163.655C196.624 163.473 196.752 163.317 196.916 163.207C197.08 163.098 197.273 163.039 197.47 163.039C197.735 163.039 197.989 163.144 198.176 163.331C198.363 163.518 198.468 163.772 198.468 164.037Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M198.468 168.49C198.468 168.687 198.409 168.88 198.3 169.044C198.19 169.208 198.034 169.336 197.852 169.411C197.67 169.487 197.469 169.507 197.276 169.468C197.082 169.43 196.904 169.335 196.765 169.195C196.625 169.056 196.53 168.878 196.492 168.684C196.453 168.491 196.473 168.29 196.549 168.108C196.624 167.926 196.752 167.77 196.916 167.66C197.08 167.551 197.273 167.492 197.47 167.492C197.735 167.492 197.989 167.597 198.176 167.784C198.363 167.971 198.468 168.225 198.468 168.49Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M197.706 178.336H197.103C196.884 178.336 196.674 178.249 196.519 178.094C196.364 177.939 196.277 177.729 196.277 177.51C196.277 177.291 196.364 177.08 196.519 176.925C196.674 176.769 196.884 176.681 197.103 176.68H197.706C197.815 176.68 197.923 176.701 198.024 176.743C198.124 176.785 198.215 176.846 198.292 176.923C198.369 177 198.43 177.092 198.471 177.193C198.512 177.293 198.533 177.401 198.532 177.51C198.532 177.729 198.445 177.939 198.29 178.094C198.136 178.249 197.926 178.336 197.706 178.336Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M171.225 205.439V185.25H162.33V205.508",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M171.225 205.439V185.25H162.33V205.508",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M171.229 185.25H166.779V205.689H171.229V185.25Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M211.069 205.439V185.25H202.17V205.508",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M211.069 205.439V185.25H202.17V205.508",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M211.069 185.25H206.619V205.689H211.069V185.25Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M213.44 181.797H32.0156V188.84H213.44V181.797Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M213.44 181.797H169.787V188.84H213.44V181.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M213.44 179.875H32.0156V182.348H213.44V179.875Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M213.439 179.875H173.744V182.348H213.439V179.875Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8128 83.5539C89.8128 83.5539 90.1423 86.4168 89.9242 87.5164C89.7061 88.6161 88.4951 89.2796 88.6018 90.0499C88.7085 90.8201 91.4647 94.7827 90.1423 96.1051C89.4713 96.8331 88.6429 97.3981 87.7202 97.7569L86.8432 99.7614C86.8432 99.7614 81.5583 103.176 79.4656 104.058C77.373 104.94 79.2429 109.12 79.2429 109.12L73.8466 107.909L72.5288 114.145C72.5288 114.145 68.4549 110.178 62.9472 108.42C57.4396 106.661 55.3516 106.879 55.3516 106.879C56.2443 104.676 56.9082 102.388 57.3328 100.049C58.1031 95.9752 58.5439 86.9457 58.5439 86.2868C58.5439 85.628 62.0656 75.4988 65.1512 73.5129C68.2368 71.527 80.7834 73.7356 87.3908 75.3689C93.9981 77.0022 91.1352 81.7536 91.1352 81.7536L89.8128 83.5539Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5943 87.0778C89.5943 87.0778 89.2649 85.8667 87.8311 86.3075C86.3974 86.7483 86.0679 87.5186 86.6201 87.5186C87.1723 87.5186 88.4761 86.8597 88.8241 87.5186C89.1721 88.1774 89.483 87.848 89.5943 87.0778Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6121 91.0391L86.9486 91.3731C86.9486 91.3731 87.9415 92.032 87.5007 93.5725C87.0599 95.113 86.6191 96.4354 86.6191 96.4354",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6463 80.5825C83.6463 80.5825 84.6393 84.7585 84.1985 85.6494C83.7577 86.5403 80.454 87.742 80.1245 88.9531C79.7951 90.1641 79.1362 96.6601 79.3543 97.8711C79.5724 99.0822 80.1245 101.175 80.6767 101.175C81.2288 101.175 85.3167 98.0892 86.8433 97.9779C88.3698 97.8665 87.7202 100.623 86.95 101.504C86.1797 102.386 84.63 102.604 84.7506 103.597C84.8712 104.59 86.8433 108 84.6393 110.975C82.4353 113.949 79.9064 113.295 77.2616 111.193C74.6168 109.091 74.1807 105.578 74.9416 103.597C75.7026 101.616 76.9229 96.4374 77.0343 94.1267C77.1457 91.816 76.5935 88.8417 74.9416 89.4867C73.2898 90.1316 74.6122 96.6462 73.4012 98.0753C72.1901 99.5044 67.3413 103.583 66.0236 103.583C64.7058 103.583 57.5416 100.391 57.3236 100.057C57.1055 99.7225 57.9824 84.972 57.1055 79.1395C56.2285 73.307 58.3165 69.1171 65.0306 67.1358C71.7447 65.1545 83.985 68.8016 83.985 68.8016C83.985 68.8016 82.774 66.8203 85.4141 65.9387C88.0543 65.0571 94.3322 67.4792 94.773 71.4464C95.2138 75.4136 92.917 75.5203 93.2325 76.838C93.548 78.1558 97.7472 80.6939 95.5525 82.7865C93.3578 84.8792 89.8268 83.5568 89.8268 83.5568L89.386 80.1417C89.386 80.1417 87.0613 77.2788 83.6463 80.5825Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1981 88.8451L73.7396 88.5156C73.7396 88.5156 71.5356 89.0631 71.3175 90.2742C71.0994 91.4852 70.8767 94.3481 71.5356 94.4502C72.1944 94.5523 72.1991 93.7913 72.1991 92.7983C72.1991 91.8054 72.1991 90.2649 73.076 89.7174C73.8323 89.34 74.6551 89.1146 75.4981 89.0539L84.4208 89.9355L92.7728 90.599V89.1652L84.1981 88.8451Z",
    fill: "#5E5E5E",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7103 93.1289C76.7103 93.1289 77.0444 89.6072 75.2812 88.6142C73.518 87.6212 72.3069 90.3774 72.2002 92.7902C72.0935 95.203 73.7407 98.1865 75.8333 97.6344",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7103 93.1289C76.7103 93.1289 77.0444 89.6072 75.2812 88.6142C73.518 87.6212 72.3069 90.3774 72.2002 92.7902C72.0935 95.203 73.7407 98.1865 75.8333 97.6344",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7997 90.6016C92.7997 90.6016 93.0177 93.1304 92.0294 94.3414C91.6544 94.7818 91.2072 95.1552 90.707 95.4457",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M123.49 111.101L119.063 126.594L115.746 135.447L112.15 144.987C112.15 144.987 102.188 144.853 97.7658 144.022C93.3438 143.192 85.377 140.361 85.377 140.361C89.3104 134.083 92.3554 127.291 94.425 120.177C96.3042 113.607 97.7611 108.336 97.7611 108.336L123.49 111.101Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M101.32 118.203C101.32 118.203 98.0072 130.095 96.6523 132.504L112.753 134.912C112.753 134.912 115.765 129.641 118.024 120.458L101.32 118.203Z",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M100.416 120.914L117.125 123.169",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6621 124.82L115.717 126.95",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3398 128.797L114.45 131.057",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M108.841 130.32L105.682 138.983L110.8 140.036L112.609 134.014",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4805 133.406L97.1018 134.613",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0293 134.312L96.6506 135.519",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5762 135.211L96.2021 136.413",
    stroke: "#A3A3A3",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M98.462 109.422L96.4668 116.34L119.76 119.138L122.019 112.215L98.462 109.422Z",
    fill: "#548AFF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2971 110.781L99.8029 110.832L98.8749 114.08L98.3691 114.025L99.2971 110.781Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M100.383 111.826L99.7199 114.146L99.2559 114.1L100.184 110.852L100.815 110.917L100.787 112.902L101.335 110.972L101.799 111.019L100.871 114.243L100.351 114.192L100.383 111.826Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M102.165 113.786L103.302 111.192L103.766 111.243L102.374 114.417L101.617 114.338L102.039 111.062L102.55 111.114L102.165 113.786Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M103.732 112.03C103.773 111.802 103.9 111.599 104.086 111.463C104.273 111.326 104.505 111.267 104.734 111.297C105.231 111.348 105.416 111.672 105.268 112.187L104.804 113.863C104.765 114.09 104.639 114.294 104.453 114.431C104.267 114.567 104.035 114.627 103.806 114.596C103.31 114.545 103.119 114.224 103.268 113.705L103.732 112.03ZM103.732 113.793C103.667 114.02 103.732 114.118 103.904 114.136C104.075 114.155 104.191 114.076 104.256 113.844L104.753 112.104C104.818 111.872 104.753 111.775 104.581 111.756C104.409 111.737 104.293 111.816 104.228 112.048L103.732 113.793Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M105.817 111.445L106.322 111.496L105.394 114.744L104.889 114.693L105.817 111.445Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 113.717L107.459 114.148C107.424 114.375 107.301 114.578 107.117 114.715C106.933 114.852 106.703 114.912 106.476 114.881C105.979 114.83 105.808 114.505 105.951 113.99L106.415 112.315C106.452 112.088 106.576 111.884 106.76 111.746C106.945 111.609 107.175 111.548 107.404 111.578C107.9 111.629 108.072 111.953 107.928 112.468L107.835 112.784L107.371 112.733L107.469 112.385C107.538 112.158 107.469 112.06 107.297 112.042C107.125 112.023 107.014 112.102 106.944 112.334L106.448 114.074C106.383 114.306 106.448 114.399 106.624 114.417C106.801 114.436 106.907 114.362 106.972 114.13L107.107 113.666L107.585 113.717Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M108.578 113.134L109.274 113.208L109.139 113.672L108.448 113.603L108.179 114.531L109.051 114.623L108.921 115.087L107.529 114.944L108.457 111.719L109.849 111.863L109.719 112.327L108.842 112.234L108.578 113.134Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M119.25 114.276C119.293 114.628 119.228 114.984 119.064 115.298C118.9 115.612 118.644 115.868 118.331 116.033C118.017 116.198 117.661 116.264 117.309 116.222C116.958 116.179 116.627 116.031 116.362 115.796C116.097 115.562 115.909 115.252 115.824 114.908C115.739 114.564 115.761 114.202 115.887 113.871C116.012 113.54 116.236 113.255 116.527 113.054C116.819 112.852 117.165 112.745 117.519 112.745C117.951 112.72 118.376 112.866 118.7 113.153C119.025 113.44 119.222 113.844 119.25 114.276Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M102.745 158.965C102.745 158.965 106.893 149.147 107.306 145.273C107.719 141.398 107.997 137.802 108.967 136.698C109.937 135.594 112.15 130.336 112.563 128.81C112.976 127.283 113.955 125.766 115.05 126.87C116.145 127.975 115.746 130.606 115.329 131.575C114.911 132.545 114.359 134.067 114.359 134.067L117.263 130.884L119.064 126.597C119.064 126.597 120.586 126.597 120.859 127.989C121.133 129.381 122.799 131.445 122.381 132.689C122.078 133.478 121.486 134.122 120.725 134.489C120.725 134.489 121.416 137.946 121.277 139.19C120.962 140.823 120.08 142.293 118.785 143.338C117.393 144.442 113.533 148.038 113.533 148.038C113.533 148.038 115.468 162.7 113.533 169.892C111.598 177.084 108.137 179.298 105.645 179.715C103.153 180.133 98.3184 174.611 98.3184 174.611C98.3184 174.611 103.436 171.967 102.745 158.965Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M120.725 134.484L118.512 136.698",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M117.264 130.886L119.477 129.086",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8249 104.092C53.8249 104.092 57.69 103.164 63.5689 105.642C67.8742 107.382 71.6573 110.205 74.5518 113.836C75.8238 115.547 76.863 117.419 77.642 119.404C77.642 119.404 55.2169 110.746 52.7438 110.746H47.1758C47.1758 110.746 50.1129 104.403 53.8249 104.092Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M130.848 205.708C112.905 189.932 84.9119 189.932 84.9119 189.932L80.7359 185.914H31.0508V205.936",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M130.848 205.708C112.905 189.932 84.9119 189.932 84.9119 189.932L80.7359 185.914H31.0508V205.936",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8303 190.859C83.8303 190.859 81.5103 200.914 77.0234 205.243",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4391 190.094C80.6901 194.056 77.8456 197.437 74.2402 199.838",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7924 108.895C47.7924 108.895 51.1936 108.12 57.8473 109.512C64.5011 110.904 74.2404 116.625 78.5696 118.481C82.8987 120.337 86.3044 120.495 87.0793 123.279C87.8542 126.063 96.3593 152.353 100.071 155.295C105.542 159.629 110.743 167.238 104.711 173.544C101.152 177.256 96.3593 177.567 94.1924 176.792C92.0256 176.017 86.7684 170.607 86.7684 168.904V166.737L76.5604 154.984C76.5604 154.984 78.7273 173.391 79.6553 175.864C80.5833 178.337 83.0564 181.896 83.0564 183.441C83.0564 184.986 79.4976 188.081 75.3216 190.712C71.1456 193.343 66.9696 195.663 57.3833 196.127C47.7971 196.591 36.3456 195.041 33.8724 191.793C31.3993 188.545 28.3044 184.68 27.9936 179.265C27.6827 173.85 26.6016 152.511 26.6016 152.511C26.6016 152.511 27.2233 135.185 27.6873 129.464C28.1513 123.743 29.3856 120.031 32.3273 118.792C35.2691 117.553 45.7833 108.895 47.7924 108.895Z",
    fill: "#548AFF",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5938 144.555C53.0177 145.222 53.4826 145.862 53.9857 146.471",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M45.627 122.961C45.627 122.961 47.2881 134.561 51.4455 142.556",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7129 137.5C46.7129 137.5 50.114 148.483 55.3711 154.204",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8262 145.695L76.5611 154.975",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5059 142.914L67.7123 144.357",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8184 147.094L74.0892 152.351",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M77.178 126.68C77.178 126.68 69.9118 133.64 70.0649 141.681",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M100.07 155.297C100.07 155.297 102.697 160.401 98.8316 164.113C94.9665 167.825 86.7676 166.739 86.7676 166.739V168.906C86.7676 170.609 92.0247 176.019 94.1916 176.794C96.3585 177.569 101.152 177.258 104.71 173.546C110.752 167.24 105.541 159.626 100.07 155.297Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6547 175.865L71.3027 167.977",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6641 163.484L74.8583 169.363",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 171.766C55.5007 172.196 56.1209 172.583 56.7662 172.926",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9688 158.227C36.9688 158.227 46.2766 165.493 52.1972 169.827",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8223 162.867C38.8223 162.867 45.6245 167.818 46.7103 168.435",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9717 166.344H67.6277C68.766 166.344 69.8577 166.796 70.6626 167.601C71.4675 168.406 71.9197 169.497 71.9197 170.636V201.956C71.9197 202.786 71.5897 203.583 71.0023 204.17C70.415 204.758 69.6183 205.088 68.7877 205.088H29.8117C28.981 205.088 28.1844 204.758 27.597 204.17C27.0097 203.583 26.6797 202.786 26.6797 201.956V170.636C26.6797 169.497 27.1319 168.406 27.9368 167.601C28.7417 166.796 29.8334 166.344 30.9717 166.344Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2607 166.344H63.9167C65.0551 166.344 66.1467 166.796 66.9517 167.601C67.7566 168.406 68.2087 169.497 68.2087 170.636V201.956C68.2087 202.786 67.8788 203.583 67.2914 204.17C66.704 204.758 65.9074 205.088 65.0767 205.088H26.1007C25.2701 205.088 24.4735 204.758 23.8861 204.17C23.2987 203.583 22.9688 202.786 22.9688 201.956V170.636C22.9687 169.497 23.4209 168.406 24.2258 167.601C25.0308 166.796 26.1224 166.344 27.2607 166.344Z",
    fill: "#636363",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5516 207.792V177.72C31.5516 177.351 31.4049 176.997 31.1439 176.736C30.8828 176.475 30.5288 176.328 30.1596 176.328C29.7904 176.328 29.4363 176.475 29.1753 176.736C28.9142 176.997 28.7676 177.351 28.7676 177.72V207.792H31.5516Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8406 207.792V177.72C56.8406 177.351 56.694 176.997 56.4329 176.736C56.1719 176.475 55.8178 176.328 55.4486 176.328C55.0795 176.328 54.7254 176.475 54.4643 176.736C54.2033 176.997 54.0566 177.351 54.0566 177.72V207.792H56.8406Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataInvoice);
export default __webpack_public_path__ + "static/media/nodataInvoice.fb428dec1edf0aaea9433a912523fc1b.svg";
export { ForwardRef as ReactComponent };